/** Full-page blocker until the user acts on the consent banner. */

const BLOCKER_ID = "cmp-page-blocker";

let lockDepth = 0;
let savedHtmlOverflow = "";
let savedBodyOverflow = "";
let strictBlock = false;

export function setStrictPageBlock(enabled: boolean): void {
  strictBlock = enabled;
}

export function isStrictPageBlock(): boolean {
  return strictBlock;
}

export function shouldBlockPageUntilConsent(themeJson: unknown): boolean {
  const theme = (themeJson || {}) as {
    compliance?: { method?: string; blockPageUntilConsent?: boolean };
  };
  const compliance = theme.compliance || {};
  if (typeof compliance.blockPageUntilConsent === "boolean") {
    return compliance.blockPageUntilConsent;
  }
  // Explicit consent: block interaction until a choice (default).
  return compliance.method !== "IMPLICIT";
}

/** @param force When false, do not lock (reopen from privacy widget). */
export function acquirePageLock(force = true): void {
  if (!force) return;
  lockDepth += 1;
  if (lockDepth > 1) return;

  if (!document.getElementById(BLOCKER_ID)) {
    const blocker = document.createElement("div");
    blocker.id = BLOCKER_ID;
    blocker.className = "cmp-page-blocker";
    blocker.setAttribute("aria-hidden", "true");
    document.body.appendChild(blocker);
  }

  savedHtmlOverflow = document.documentElement.style.overflow;
  savedBodyOverflow = document.body.style.overflow;
  document.documentElement.style.overflow = "hidden";
  document.body.style.overflow = "hidden";
}

export function releasePageLock(): void {
  if (lockDepth <= 0) return;
  lockDepth -= 1;
  if (lockDepth > 0) return;

  document.getElementById(BLOCKER_ID)?.remove();
  document.documentElement.style.overflow = savedHtmlOverflow;
  document.body.style.overflow = savedBodyOverflow;
  strictBlock = false;
}

/** Release lock when banner and preferences UI are both closed. */
export function releasePageLockIfIdle(): void {
  if (document.getElementById("cmp-banner") || document.getElementById("cmp-prefs")) return;
  lockDepth = 0;
  document.getElementById(BLOCKER_ID)?.remove();
  document.documentElement.style.overflow = savedHtmlOverflow;
  document.body.style.overflow = savedBodyOverflow;
  strictBlock = false;
}
